import React from 'react';
import { bool, object, string } from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { PriceUpfrontTooltip, TooltipWrapper, useDisplayPrice } from '@fiverr-private/gig_listings';
import { convertFromUSD } from '../../../utils/currencyConverter';
import './index.scss';

export const Price = ({ containerClassName, priceInUSD, currency, isHourlyPrice }) => {
    const text = isHourlyPrice ? 'listings.expert_card.footer.hourlyPrice' : 'listings.expert_card.footer.price';
    const { grossPriceInUSD, showTooltip } = useDisplayPrice({
        originalPrice: priceInUSD,
        hourlyRate: priceInUSD,
        showHourlyPrice: isHourlyPrice,
        currency,
    });

    const price = convertFromUSD(grossPriceInUSD, currency);

    const priceContent = (
        <div className={classnames('footer-price co-text-darker', containerClassName)}>
            <I18n
                k={text}
                params={{ price }}
                templates={{
                    priceSection: (text) => <span className="text-bold">{text}</span>,
                }}
            />
        </div>
    );

    return (
        <TooltipWrapper content={<PriceUpfrontTooltip />} shouldRenderTooltip={showTooltip} position="bottom">
            {priceContent}
        </TooltipWrapper>
    );
};

Price.propTypes = {
    priceInUSD: string.isRequired,
    currency: object,
    containerClassName: string,
    isHourlyPrice: bool,
};
